// src/components/Map/ClockLines/ClockLines.js
import { useMemo } from "react";
import { Source, Layer } from "react-map-gl/mapbox";

export default function ClockLines({ id, showClockLines, center }) {
  function generateClockLines(center, radiusMeters = 500) {
    const [lng, lat] = center;
    const features = [];
    for (let i = 0; i < 12; i++) {
      const angle = (i * 30 * Math.PI) / 180;
      const dx = (radiusMeters / 111320) * Math.cos(angle);
      const dy = (radiusMeters / 110540) * Math.sin(angle);
      features.push({
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [
            [lng, lat],
            [lng + dx, lat + dy]
          ]
        }
      });
    }
    return { type: "FeatureCollection", features };
  }

  const data = useMemo(() => generateClockLines(center, 4000), [center]);

  if (!showClockLines) return null;

  return (
    <Source id={`clock-lines-src-${id}`} type="geojson" data={data}>
      <Layer
        id={`clock-lines-layer-${id}`}
        type="line"
        paint={{
          "line-color": "#4e86cf",
          "line-width": 3
        }}
      />
    </Source>
  );
}
